export default __webpack_public_path__ + "static/logotransparent-47b96e8f4c6bffa55c23ea0f64ce53a9.png";